import React from 'react'
import {
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import { useAppDispatch, useTypedSelector } from '../../../stateStore'
import { reduxServices } from '../../../reducers/reduxServices'
import { AccessCardTableProps } from '../../../types/EmployeeDirectory/AccessCardDetails/accessCardDetailsTypes'
import OPageSizeSelect from '../../../components/ReusableComponent/OPageSizeSelect'
import OPagination from '../../../components/ReusableComponent/OPagination'
import { conditionalDefaultStringEmpty } from '../../../utils/helper'

const TableHeaderTitles = [
  'ID',
  'Full Name',
  'Department',
  'Designation',
  'Access Card ID',
]

const AccessCardTable = ({
  paginationRange,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
}: AccessCardTableProps): JSX.Element => {
  // Mock data for the table

  const dispatch = useAppDispatch()
  const accessCardListSize = useTypedSelector(
    reduxServices.accessCardDetails.selectors.listSize,
  )
  const getAccessCardsList = useTypedSelector(
    reduxServices.accessCardDetails.selectors.getAcessCards,
  )
  const handlePageSize = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(event.target.value))
    setCurrentPage(1)
    dispatch(reduxServices.app.actions.setPersistCurrentPage(1))
  }

  return (
    <>
      <CTable striped align="middle" responsive>
        <CTableHead>
          <CTableRow>
            {TableHeaderTitles.map((item, index) => {
              return (
                <CTableHeaderCell key={index} scope="col">
                  {item}
                </CTableHeaderCell>
              )
            })}
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {getAccessCardsList?.length > 0 &&
            getAccessCardsList?.map((item, index) => {
              return (
                <CTableRow key={index}>
                  <CTableDataCell style={{ width: '60px' }}>
                    {item?.id}
                  </CTableDataCell>
                  <CTableDataCell>{item?.fullName}</CTableDataCell>
                  <CTableDataCell>{item?.departmentName}</CTableDataCell>
                  <CTableDataCell>{item?.designation}</CTableDataCell>
                  <CTableDataCell>
                    {conditionalDefaultStringEmpty(
                      String(item?.accessCard),
                      'N/A',
                    )}
                  </CTableDataCell>
                </CTableRow>
              )
            })}
        </CTableBody>
      </CTable>
      <CRow>
        <CCol lg={3} md={6}>
          <strong>
            {accessCardListSize
              ? `Total Records: ${accessCardListSize}`
              : `No Records Found...`}
          </strong>
        </CCol>
        <CCol lg={3} md={6}>
          {accessCardListSize > 20 && (
            <OPageSizeSelect
              handlePageSizeSelectChange={handlePageSize}
              options={[20, 40, 60, 80, 100]}
              selectedPageSize={pageSize}
            />
          )}
        </CCol>
        {accessCardListSize > 20 && (
          <CCol
            lg={6}
            className="gap-1 d-grid d-md-flex justify-content-md-end"
          >
            <OPagination
              currentPage={currentPage}
              pageSetter={setCurrentPage}
              paginationRange={paginationRange}
            />
          </CCol>
        )}
      </CRow>
    </>
  )
}

export default AccessCardTable
